import { PodProvider } from '@/typings/pod/podProvider';
import api from '../baseApi';

export const getPodProviders = async (): Promise<PodProvider[]> => {
    const response = await api.get('Admin/PodProvider');
    return response.data;
};

export const getPodProviderById = async (id: number): Promise<PodProvider[]> => {
    const response = await api.get(`Admin/PodProvider/${id}`);
    return response.data;
};
